import styled, { Theme } from '@themes/theme'
import { css } from '@emotion/core'

export const LossLimitWrap = styled.div`
  background-color: ${props => props.theme.color.themeTxt};
  padding: 30px 14px 14px;
  height: 100%;
  overflow-y: auto;
  container-type: size;
  container-name: limit-wrap;
  .limit-price {
    &--title {
      margin: 0 6px 5px 6px;
      color: ${props => props.theme.color.modalTxt};
      font-size: 1.6rem;
      font-weight: 700;
      text-align: left;
    }
    &--description {
      width: calc(100% - 12px);
      margin: 0 6px 24px 6px;
      color: #929292;
      font-size: 1.4rem;
      font-weight: 500;
      text-align: left;
      letter-spacing: -0.01em;
    }
  }
  .setting-button {
    flex-shrink: 0;
    height: 45px;
    border-radius: 6px;
  }
`

export const LimitPriceRadio = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: 8px; 
  margin-bottom: calc(40px + 45px - 14px);
  .limit-price-radio {
    &--button {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 61px;
      margin: 0;
      padding: 0 20px;
      background-color: ${theme.color.whiteBg};
      border-radius: 8px;
      transition: border 0.3s;
      border: 1px solid transparent;
      &:has(.ant-radio-checked) {
        border: 1px solid ${theme.color.modalSubTxt};
      }
      .ant-radio-inner {
        width: 18px;
        height: 18px;
        border-color: ${theme.color.modalDarkBg};
        border-width: 2px;
        background-color: transparent;
        &::after {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 10px;
          height: 10px;
        }
      }
      .ant-radio-checked .ant-radio-inner {
        border-color: ${theme.color.accordion2};
        &::after {
          background-color: ${theme.color.accordion2};
        }
      }
      span:nth-child(2) {
        padding: 0;
      }
      &--label {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
      &--text {
        color: ${theme.color.modalTxt};
        font-size: 1.6rem;
        font-weight: 500;
      }
      &--check {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
      }
    }
  }
  .gmoney-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }
`

export const PopupButton = css`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 45px;
  border-radius: 0;
  font-size: 1.4rem;
`
